import Icon from '@mdi/react';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { useThemeContext } from '../../contexts';

type HeaderButtonProps = {
  ariaLabel?: string;
  onPress?: () => void;
  children?: React.ReactElement;
  icon: string;
  hidden?: boolean;
};

/**
 * Header button component
 *
 * @param {HeaderButtonProps} props
 * @return {React.FC}
 */
const HeaderButton: React.FC<HeaderButtonProps> = (props: HeaderButtonProps) => {
  const { theme } = useThemeContext();

  const styles = StyleSheet.create({
    headerButtonStyle: {
      display: 'flex',
      alignItems: 'center',
      flex: 1
    },
    headerButtonIconStyle: {
      width: 24,
      color: theme.primary
    }
  });

  return props.hidden ? null : (
    <Pressable
      style={styles.headerButtonStyle}
      onPress={props.onPress}
      aria-label={props.ariaLabel}>
      <Icon path={props.icon} style={styles.headerButtonIconStyle} />
    </Pressable>
  );
};

export default HeaderButton;
